import {
  BmiCategory,
  GoalOverview,
  NutritionStratergy,
  WorkoutFocus,
  LongTerm,
} from "@utils/defaultImages";

export const getAdviseData = ({ selectedTags, t }) => {
  return [
    {
      label: t("BMI & Category"),
      key: "average_sleep_duration",
      icon: <BmiCategory className="w-[24px] h-[24px]" />,
      tabColor: "#F0FFFF",
      value: selectedTags?.adviseMeDescription?.["BMI & Category"],
    },
    {
      label: t("Goal Overview"),
      key: "wake_ups_per_week",
      icon: <GoalOverview className="w-[24px] h-[24px]" />,
      tabColor: "#FFF0FB",
      value: selectedTags?.adviseMeDescription?.["Goal Overview"],
    },
    {
      label: t("Nutrition Strategy"),
      key: "sleep_consistency_days",
      icon: <NutritionStratergy className="w-[24px] h-[24px]" />,
      tabColor: "#FFF6F0",
      value: selectedTags?.adviseMeDescription?.["Nutrition Strategy"],
    },
    {
      label: t("Workout Focus"),
      key: "advice_followed",
      icon: <WorkoutFocus className="w-[24px] h-[24px]" />,
      tabColor: "#F5FFF0",
      value: selectedTags?.adviseMeDescription?.["Workout Focus"],
    },
    {
      label: t("Long-Term Plan"),
      key: "advice_followed",
      icon: <LongTerm className="w-[24px] h-[24px]" />,
      tabColor: "#F5FFF0",
      value: selectedTags?.adviseMeDescription?.["Long-Term Plan"],
    },
  ];
};